import ScatterBase from '@fusioncharts/charts/src/chart/_internal/scatterbase';
import ErrorScatterDataset from '../../dataset/errorscatter';

const ERRORSCATTER = 'errorscatter';
class ErrorScatter extends ScatterBase {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'ErrorScatter';
  }

  constructor () {
    super();
    this.isXY = true;
    this.defaultZeroPlaneHighlighted = false;
    this.useErrorGroup = true;
    this.isErrorChart = true;
    this.hasAnchor = true;
    // this.fireGroupEvent = true;
    this.initAnimation = true;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'ErrorScatter';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.defaultDatasetType = ERRORSCATTER;
    config.enablemousetracking = true;
  }
  getDSGroupdef () {
    // this fn overrides
  }
  getDSdef () {
    return ErrorScatterDataset;
  }
}
export default ErrorScatter;
